// App.js
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./components/Auth/Login";
import Register from "./components/Auth/Register";
import ResetPassword from "./components/Auth/ResetPassword";
import Home from "./components/Home";
import Contact from "./components/Contact";
import { Dashboard } from "./components/Dashboard";
import { Documents } from "./components/Documents";
import AdminPanel from "./components/AdminPanel";
import { Loader } from "./components/ui/loader";
import PrivacyPolicy from "./components/PrivacyPolicy";
import FormulaGuidePage from "./components/ui/FormulaGuidePage";
import TermsOfService from "./components/TermsOfService";

// Strona weselna — lazy (osobny chunk, ładuje się tylko pod /renia-i-bartek).
const ReniaIBartek = lazy(() => import("./components/wedding/ReniaIBartek"));
const WeddingAdmin = lazy(() => import("./components/wedding/admin/WeddingAdmin"));

// Wspólny fallback ładowania stron weselnych (ciemne tło jak strona).
const weddingFallback = (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0d1322",
    }}
  >
    <Loader />
  </div>
);

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: '#f8fafc'
    }}>
      <Loader />
    </div>
  );
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/renia-i-bartek"
            element={
              <Suspense fallback={weddingFallback}>
                <ReniaIBartek />
              </Suspense>
            }
          />
          <Route
            path="/renia-i-bartek/galeria"
            element={
              <Suspense fallback={weddingFallback}>
                <WeddingAdmin />
              </Suspense>
            }
          />
          <Route
            path="/renia-i-bartek/admin"
            element={<Navigate to="/renia-i-bartek/galeria" replace />}
          />
          <Route path="/" element={<Home />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/regulamin" element={<TermsOfService />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/jak-przygotowac-szablon" element={<FormulaGuidePage />} />
          <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/documents" element={<PrivateRoute><Documents /></PrivateRoute>} />
          <Route path="/admin-panel-9834" element={<PrivateRoute><AdminPanel /></PrivateRoute>} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
